/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import CN from 'classnames';
import { Button } from 'components/atoms';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export interface LeftNavProps {
  [x: string]: any;
  menuItemList?: any;
  firstRoute?: string | undefined;
  setIsMenuDrawerOpen?: any;
}

export const LeftNav: FC<LeftNavProps> = ({
  menuItemList = [],
  firstRoute,
  userDetails,
  setIsMenuDrawerOpen = undefined,
}: LeftNavProps) => {
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState<any>([]);
  const { userDetails: user }: any = useSelector<any>((state) => state.user);

  useEffect(() => {
    const filterSubMenus = menuItemList.map((item: any) => {
      return {
        ...item,
        subMenuItems: item.subMenuItems?.filter((item: any) => {
          return item.isActive;
        }),
      };
    });

    const filterMainMenu = filterSubMenus.filter((item: any) => {
      return item.isActive;
    });

    setMenuItems(filterMainMenu);
  }, [userDetails]);

  const clickMainItem = (selectedItem: any) => {
    const itemToUpdate = menuItems;
    if (!selectedItem?.isSelected) {
      if (!selectedItem.hasSubmenu) {
        navigate(selectedItem.url);
        setIsMenuDrawerOpen(false);
      }
      const updatedItems = itemToUpdate.map((item: any) => {
        if (item.mainMenuId === selectedItem.mainMenuId) {
          return {
            ...item,
            isSelected: true,
            subMenuItems: item.subMenuItems.map((subItem: any) => {
              return {
                ...subItem,
                isSelected: false,
              };
            }),
          };
        }
        return {
          ...item,
          isSelected: false,
          subMenuItems: item.subMenuItems.map((subItem: any) => {
            return {
              ...subItem,
              isSelected: false,
            };
          }),
        };
      });
      setMenuItems(updatedItems);
    } else {
      navigate(selectedItem.url);
      setIsMenuDrawerOpen(false);
    }
  };

  useEffect(() => {
    if (menuItems.length > 0 && (firstRoute || firstRoute === '')) {
      const itemsToUpdate = menuItems.map((item: any) => ({
        ...item,
        isSelected: item.url === `/${firstRoute}`,
      }));

      setMenuItems(itemsToUpdate);
    }
  }, [firstRoute, userDetails, menuItems.length]);

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  return (
    <div className="side-bar-item-container h-full w-full mt-5">
      <ul className="flex flex-col h-full gap-y-3">
        {menuItems?.map((item: any, idx: any) => (
          <li key={item?.mainMenuItemKey} className="side-bar-item h-fit cursor-pointer">
            <div
              onClick={(e) => {
                e.stopPropagation();
                clickMainItem(item);
              }}
              className={CN(
                'side-bar-item__container flex items-center rounded-lg justify-start h-full w-full py-3 transition-all duration-500 pr-2 pl-8',
                {
                  'bg-[#F7941E] !text-white ': item?.isSelected,
                  'hover:bg-[#f7e3ca] text-[#F7941E]': !item?.isSelected,
                },
              )}
            >
              <div className="flex items-center justify-between gap-x-3 w-[55%]">
                <span className="text-[24px] leading-none font-normal">{item?.icon}</span>
                <p className="font-medium text-base w-full text-left">{item?.name}</p>
              </div>
            </div>
          </li>
        ))}

        <div className="w-full justify-center items-center px-8 mt-5">
          <Button
            size="sm"
            isBlock
            className="hidden md:block mr-8"
            onClick={() => {
              if (user?.status !== 'completed') {
                notify('Please complete your profile before uploading videos.', 'error');
              } else {
                navigate('/videos/upload');
                setIsMenuDrawerOpen(false);
              }
            }}
          >
            <i className="ri-add-line pr-1" />
            Upload
          </Button>
        </div>
      </ul>
    </div>
  );
};

export default LeftNav;
